import React, { useState } from 'react'
import { useFetch } from 'use-http'

import { Box, Button, Card, Heading, Text } from '@myxplor/stardust'

import sortObjectsBy from '~/src/utils/sortObjectsBy'

import { AccountDetail } from './types'

interface Props {
  account: AccountDetail
}

const ApiKeyList = ({ account }: Props) => {
  const [createdApiKeys, setCreatedApiKeys] = useState<Papi.ApiKey[]>([])

  const apiKeyRequest = useFetch(`/api/v1/accounts/${account.id}/api_keys`, {})

  const onApiKeyCreate = async () => {
    const response = await apiKeyRequest.post()

    if (apiKeyRequest.response.ok) {
      setCreatedApiKeys((apiKeys) => [...apiKeys, response.data])
    }
  }

  const apiKeys = sortObjectsBy([...createdApiKeys, ...account.api_keys], 'id').reverse()

  return (
    <Card>
      <Box display="flex" flexDirection="column">
        <Box alignItems="center" display="flex" justifyContent="space-between" padding="small">
          <Heading level={5}>API keys</Heading>
          <Button disabled={apiKeyRequest.loading} onClick={onApiKeyCreate}>
            Generate API Key
          </Button>
        </Box>
        {apiKeys.length === 0 && (
          <Box borderColor="lowestEmphasis" border="1px solid" padding="small">
            <Text>No API keys</Text>
          </Box>
        )}
        {apiKeys.map((apiKey) => (
          <Box key={apiKey.id} borderColor="lowestEmphasis" border="1px solid" display="flex" padding="small">
            <Box display="flex" flexDirection="column" width="32px">
              <Text prefab="overline">ID</Text>
              <Text lineHeight={1.4} prefab="body">
                {apiKey.id}
              </Text>
            </Box>
            <Box display="flex" flexDirection="column" flexGrow={1} paddingRight="small">
              <Text prefab="overline">Key {apiKey.key ? '(Live)' : '(Hashed)'}</Text>
              <Text lineHeight={1.4} prefab="body">
                {apiKey.key || 'XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX'}
              </Text>
            </Box>
            <Box display="flex" flexDirection="column">
              <Text prefab="overline">Created</Text>
              <Text align="right" lineHeight={1.4} prefab="body">
                UTC {apiKey.inserted_at}
              </Text>
            </Box>
          </Box>
        ))}
      </Box>
    </Card>
  )
}

export default React.memo(ApiKeyList)
